import { endsWith } from 'lodash-es';

const VIDEO_EXTENSIONS = [
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.webm',
  '.flv',
  '.wmv',
  '.mpeg',
  '.mpg',
  '.m4v',
  '.3gp',
];
const isVideoFile = (fileName = '') => {
  return VIDEO_EXTENSIONS.some((ext) => endsWith(fileName.toLowerCase(), ext));
};

export default isVideoFile;
